import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const AuthControlWrapper = styled.div`
    width: 100%;
`;

export const  TariffListWrapper = styled.div`
    margin-bottom: 52px;
    width: 100%;

    @media(max-width: 768px) {
        margin-bottom: 36px;
    }
`;

export const  DevicesWrapper = styled.div`
    flex-direction: column;
`;

export const  DevicesTitle = styled.div`
    ${FONTS.H2};
    display: block;
    margin-bottom: 12px;

    @media(max-width: 768px) {
        ${FONTS.H3};
    }
`;

export const  DevicesSubTitle = styled.div`
    ${FONTS.L};

    margin-bottom: 32px;
    @media(max-width: 768px) {
        ${FONTS.S};
    }
`;

export const  DevicesListWrapper = styled.div``;
